import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

// Mock until BE-1 (https://app.clickup.com/t/86c7fufcj) lands.
// Each style is the user-facing label; backend will accept the same string as filter value.
// Group keys map to `search_page.filters.style.groups.<key>` translations.
// Both lists mirror the grouped dropdowns in Listing Page 2.0
// (3D only: node 2599-73247, 3D print only: node 2599-74496,
// https://www.figma.com/design/82bsGlkDIJNqvlZjdEWH2v/Listing-Page-2.0?node-id=2599-73247).
export const STYLE_GROUPS_BY_ASSET_TYPE = {
  [ASSET_TYPE.THREE_D_ONLY]: [
    {
      key: 'era',
      styles: ['Ancient', 'Historical', 'Victorian', 'Classic', 'Vintage', 'Retro', 'Modern'],
    },
    {
      key: 'genre',
      styles: ['Fantasy', 'Sci-Fi', 'Cyberpunk', 'Steampunk', 'Postapocalyptic', 'Gothic', 'Military'],
    },
    {
      key: 'rendering',
      styles: [
        'Realistic', 'Photorealistic', 'Stylized', 'Cartoon', 'Anime', 'Pixel', 'Voxel', 'Abstract', 'Minimalist',
      ],
    },
    {
      key: 'look',
      styles: ['Grunge', 'Industrial', 'Organic', 'Playful'],
    },
  ],
  [ASSET_TYPE.THREE_D_PRINT_ONLY]: [
    {
      key: 'surface',
      styles: ['Smooth', 'Textures', 'Matte', 'Glossy', 'Transparent'],
    },
    {
      key: 'purpose',
      styles: ['Functional', 'Decorative', 'Artistic'],
    },
    {
      key: 'form',
      styles: ['Organic', 'Geometric'],
    },
    {
      key: 'subject',
      styles: ['Architectural', 'Mechanical', 'Miniature'],
    },
  ],
}

export const getStyleGroupsForAssetType = (assetType) => STYLE_GROUPS_BY_ASSET_TYPE[assetType] || []

export const getStylesForAssetType = (assetType) => (
  getStyleGroupsForAssetType(assetType).flatMap(group => group.styles)
)

// ES `at_style` is a keyword (exact-match) field holding lowercase tokens ("realistic", "sci-fi"),
// while the chips display the capitalized labels above - lowercasing a label yields its token
// (verified against production: at_style[]=realistic matches, at_style[]=Realistic returns 0).
export const styleFilterValue = (label) => label.toLowerCase()

const STYLE_LABELS_BY_FILTER_VALUE = {}
Object.values(STYLE_GROUPS_BY_ASSET_TYPE).flat().forEach((group) => {
  group.styles.forEach((label) => {
    STYLE_LABELS_BY_FILTER_VALUE[styleFilterValue(label)] = label
  })
})

// Inverse of styleFilterValue for URL hydration; undefined for tokens outside the known lists.
export const findStyleLabel = (token) => STYLE_LABELS_BY_FILTER_VALUE[token]
